import {createSlice} from "@reduxjs/toolkit";
import {setUIServiceEventSearchFilter} from "./actions";
import {ServiceEventSearchCriteria} from "@ots-frontend/ots-data";

type ServiceEventUIState = {
  searchFilter?: ServiceEventSearchCriteria
}

const INITIAL_STATE: Readonly<ServiceEventUIState> = {};

const serviceEventUISlice = createSlice({
  name: "ots-ui/service-event",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIServiceEventSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const serviceEventUIReducer = serviceEventUISlice.reducer;
